// userApi.js
import apiRequest from "./axiosInstance";

/**
 * Fetches a list of users
 * @returns {Promise<Object>} Response object from the API request
 */
export const fetchUsers = (data) => {
  const keyQuery = `key=${encodeURIComponent(data.key || "firstName")}`;
  const directionQuery = `direction=${encodeURIComponent(
    data.direction || "asc"
  )}`;
  const searchQuery = data.search
    ? `search=${encodeURIComponent(data.search)}`
    : "";

  const queryParams = [keyQuery, directionQuery, searchQuery]
    .filter(Boolean)
    .join("&");

  return apiRequest("GET", `/users?id=${data.id}&${queryParams}`);
};

export const fetchUsersById = (id) => apiRequest("GET", `/users/${id}`);

export const fetchUsersTaskPermission = () =>
  apiRequest("GET", `/users/taskPermission`);

export const fetchAllUsers = (id) => apiRequest("GET", `/users/basic/${id}`);

export const fetchUserForForm = () => apiRequest("GET", `/users/usersForForm`);

/**
 * Creates a new user
 * @param {Object} userData - Data for the new user
 * @returns {Promise<Object>} Response object from the API request
 */
export const addUser = (userData) =>
  apiRequest("post", "/users", userData, {}, {}, true);

/**
 * Updates an existing user
 * @param {string|number} id - User ID
 * @param {Object} userData - Updated user data
 * @returns {Promise<Object>} Response object from the API request
 */
export const updateUser = (id, userData) =>
  apiRequest("put", `/users/${id}`, userData, {});

export const updateUserPreferences = (id, userData) =>
  apiRequest("put", `/preferenceSettingsUpdate/${id}`, userData, {});

/**
 * Deletes a user by ID
 * @param {string|number} id - User ID
 * @returns {Promise<Object>} Response object from the API request
 */
export const deleteUser = (id) => apiRequest("delete", `/users/${id}`);

export const getDataSync = () => apiRequest("get", "/users/fetchDataSync");

export const validateSamlResponse = (data) =>
  apiRequest("post", "/auth/saml/validate", data);

export const GetUserData = () => apiRequest("get", "/userData");

/**
 * User API service module
 * @module
 */
